import { checkErrorObjectType } from '@/utils/object';
import { CanceledError, } from 'axios';
import { i18n } from '@/locales';
import errorCodes from '@/constants/errorCodes';
import ErrorType1 from './ErrorType1';
import ErrorType2 from './ErrorType2';
import ErrorType3 from './ErrorType3';
import ErrorType4 from './ErrorType4';
import ErrorTypeRaw from './ErrorTypeRaw';
import ErrorTypeAuthServer from './ErrorTypeAuthServer';
import ErrorTypeAuthServer2 from './ErrorTypeAuthServer2';
/**
 * 에러 메시지 팩
 */
const errorMessagePack = {
    invalid_request: i18n.t('views.login.alert_recheck_user_info'),
    invalid_grant: i18n.t('views.login.alert_recheck_user_info'),
};
/**
 * 허컨 에러 객체
 */
export default class BusinessError extends Error {
    /** 응답 객체 형태를 구분하기 위한 태그 */
    tag = '';
    /** (변경금지) 서버에서 주는 코드 Bad Request, FORBIDDEN .. */
    code = '';
    /** (변경금지) 상태 코드 404.. */
    status = 0;
    /** (활용가능) customCode만 가지고 프론트에서 출력하게 하려고 함. 출력 메시지 */
    message = '';
    /** (활용가능) 백엔드에서 커스텀하게 주는 코드 */
    customCode = '';
    /** [제거 예정] 메시지랑 혼선 있음 정리 필요 함 */
    reason = '';
    /** 카테고리 */
    category = '';
    constructor(data) {
        super();
        // 개발자가 임의로 출력했을 경우 new BusinessError('foo') 형태로 사용시
        if (typeof data === 'string') {
            this.tag = 'stringThrow';
            // 미정
            this.code = '';
            this.message = data;
        }
        else {
            this.tag = data.tag || '';
            this.status = data.status || 0;
            this.code = data.code || '';
            this.customCode = data.customCode || '';
            // 백엔드가 주는 code를 customCode로 사용해서 특정 메시지 출력하면 된다.
            this.message = errorMessagePack[data.customCode]
                || data.message
                || '';
            this.reason = data.reason || '';
            this.category = data.category || '';
        }
    }
    static convertErrorObject(_error) {
        const { 
        /** axiosError.code > ERR_BAD_REQUEST */
        code, 
        /** axiosError.status > 400 */
        status, 
        /** axiosError.response > any data */
        response, } = _error;
        const responseData = checkErrorObjectType(response?.data);
        // api 취소
        // 에러 핸들링 명확하게 하기 위해 미리 분리
        if (_error instanceof CanceledError) {
            return new BusinessError({
                tag: 'CanceledError',
                message: errorCodes.ERR_CANCELED.message,
            });
        }
        if (responseData instanceof ErrorType1) {
            return new BusinessError({
                tag: 'ErrorType1',
                status: status,
                code: code,
                message: responseData.data.message,
                reason: responseData.data.reason,
                // ErroryType1에서의 customCode는 reason
                customCode: responseData.data.reason,
            });
        }
        if (responseData instanceof ErrorType2) {
            return new BusinessError({
                tag: 'ErrorType2',
                status: status,
                code: code,
                message: responseData.error.message,
                category: responseData.error.category,
                // ErroryType2에서의 customCode는 errorCode
                customCode: responseData.error.errorCode,
            });
        }
        if (responseData instanceof ErrorType3) {
            return new BusinessError({
                tag: 'ErrorType3',
                status: status,
                code: code,
                message: responseData.error.message,
                customCode: responseData.error.errorCode,
            });
        }
        if (responseData instanceof ErrorType4) {
            return new BusinessError({
                tag: 'ErrorType4',
                status: status,
                code: code,
                message: responseData.error.message,
                customCode: responseData.error.errorCode,
            });
        }
        /**
         * auth 서버 에러 타입
         * https://barogo.slack.com/archives/C04UP4VFCKA/p1737533210502539
         */
        if (responseData instanceof ErrorTypeAuthServer) {
            return new BusinessError({
                tag: 'ErrorTypeAuthServer',
                status: status,
                code: code,
                message: responseData.error_description,
                customCode: responseData.error,
            });
        }
        /**
         * auth 서버 에러 타입2
         * https://barogo.slack.com/archives/C04UP4VFCKA/p1737533210502539
         */
        if (responseData instanceof ErrorTypeAuthServer2) {
            return new BusinessError({
                tag: 'ErrorTypeAuthServer2',
                status: status,
                code: code,
                message: responseData.error.message,
                category: responseData.error.category,
                customCode: responseData.error.errorCode,
            });
        }
        if (responseData instanceof ErrorTypeRaw) {
            return new BusinessError({
                tag: 'ErrorTypeRaw',
                status: status,
                code: responseData.error,
                message: responseData.error,
            });
        }
        return new BusinessError({
            tag: 'default',
            status: status,
            code: code,
            customCode: '',
            message: i18n.t('common.failure'),
        });
    }
}
